import { useState, useEffect } from "react";
import Card from "../../../components/base/Card";
import logo2 from "../../../assets/logo2.png";

export default function ContactSection() {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => entry.isIntersecting && setIsVisible(true),
			{ threshold: 0.1 }
		);
		const element = document.getElementById("contato");
		if (element) observer.observe(element);
		return () => observer.disconnect();
	}, []);

	return (
		<section id="contato" className="py-20 bg-gray-50">
			<div className="container mx-auto px-4 text-center">
				{/* 🔵 LOGO + TÍTULOS */}
				<div
					className={`flex flex-col items-center justify-center mb-16 transform transition-all duration-1000 ${
						isVisible
							? "opacity-100 translate-y-0"
							: "opacity-0 translate-y-10"
					}`}
				>
					<img
						src={logo2}
						alt="Logo Renzi Rossi Contabilidade"
						className="w-40 mb-6 drop-shadow-lg"
					/>
					<h2
						className="text-4xl font-bold text-gray-800 mb-4"
						style={{ fontFamily: "DM Sans, sans-serif" }}
					>
						Entre em Contato
					</h2>
					<p className="text-xl text-gray-600 max-w-2xl">
						Estamos prontos para atender você com o cuidado e
						atenção que seu negócio merece.
					</p>
				</div>

				{/* ⚫ SEÇÃO PRINCIPAL */}
				<div
					className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start transform transition-all duration-1000 ${
						isVisible
							? "opacity-100 translate-y-0"
							: "opacity-0 translate-y-10"
					}`}
				>
					{/* 🔹 ESQUERDA — Contatos */}
					<div className="space-y-6">
						{/* Endereço */}
						<a
							href="https://www.google.com/maps/dir/?api=1&destination=R.+Alberto+Rossi,+31,+Centro,+Poá+-+SP,+08561-620"
							target="_blank"
							rel="noopener noreferrer"
							className="block transform transition-transform duration-300 hover:-translate-y-2"
						>
							<Card className="transition-transform duration-300 hover:shadow-lg">
								<div className="flex items-center mb-4">
									<div className="hidden sm:flex w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
										<i className="ri-map-pin-line text-blue-600 text-2xl"></i>
									</div>

									<div className="text-left">
										<h4 className="text-lg font-semibold text-gray-800 mb-2">
											Endereço
										</h4>
										<p className="text-blue-600 hover:text-blue-700 font-semibold text-lg transition-colors duration-200 leading-relaxed whitespace-normal break-normal">
											R. Alberto Rossi, 31, Centro, Poá -
											SP, CEP 08561-620
										</p>
									</div>
								</div>
							</Card>
						</a>

						{/* WhatsApp */}
						<a
							href="https://wa.me/551146381343"
							target="_blank"
							rel="noopener noreferrer"
							className="block transform transition-transform duration-300 hover:-translate-y-2"
						>
							<Card className="transition-transform duration-300 hover:shadow-lg">
								<div className="flex items-center mb-4">
									<div className="hidden sm:flex w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mr-4">
										<i className="ri-whatsapp-line text-green-600 text-2xl"></i>
									</div>

									<div className="text-left">
										<h4 className="text-lg font-semibold text-gray-800 mb-2">
											WhatsApp - Atendimento Direto
										</h4>
										<p className="text-green-600 hover:text-green-700 font-semibold text-lg transition-colors duration-200">
											+55 11 4638-1343
										</p>
									</div>
								</div>
							</Card>
						</a>

						{/* E-mail */}
						<a
							href="mailto:contato@renzirossi.com.br"
							className="block transform transition-transform duration-300 hover:-translate-y-2"
						>
							<Card className="transition-transform duration-300 hover:shadow-lg">
								<div className="flex items-center mb-4">
									<div className="hidden sm:flex w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
										<i className="ri-mail-line text-purple-600 text-2xl"></i>
									</div>

									<div className="text-left">
										<h4 className="text-lg font-semibold text-gray-800 mb-2">
											E-mail
										</h4>
										<p className="text-purple-600 hover:text-purple-700 text-lg font-semibold transition-colors duration-200 break-all">
											contato@renzirossi.com.br
										</p>
									</div>
								</div>
							</Card>
						</a>
					</div>

					{/* 🔺 DIREITA — Mapa */}
					<div>
						<Card>
							<h4 className="text-lg font-semibold text-gray-800 mb-4 text-left">
								Localização
							</h4>
							<div className="w-full h-96 rounded-lg overflow-hidden">
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.707!2d-46.344255!3d-23.525261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce7a3e9c7cb5b9%3A0xdefb3e2d8b7b8c65!2sR.%20Alberto%20Rossi%2C%2031%20-%20Centro%2C%20Po%C3%A1%20-%20SP%2C%2008561-620!5e0!3m2!1spt-BR!2sbr!4v1700000000000"
									width="100%"
									height="100%"
									style={{ border: 0 }}
									allowFullScreen
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
									title="Localização Contabilidade Renzi Rossi"
								></iframe>
							</div>
						</Card>
					</div>
				</div>
			</div>
		</section>
	);
}
